<template>
  <c-box>
    <c-tabs variant="soft-rounded" @change="(index) => (activeNewsTab = index)" :is-manual="true">
      <mobile-tab-menu
        v-chakra
        :d="{ lg: 'none' }"
        :mt="{ base: '3xl', sm: '4xl' }"
        :mb="{ base: 'md', sm: 'lg' }"
        :currentPage="String($t(newsTabTranslationKeys[activeNewsTab]))"
      >
        <template>
          <c-tab-list
            display="block"
            v-chakra="{
              '& button[aria-selected=true], & button[data-selected]': {
                color: 'white',
                bg: 'brand.purple',
                borderColor: 'brand.purple',
              },
            }"
          >
            <c-tab px="xl" py="md" font-weight="normal">{{ $t("news.news.title") }}</c-tab>
            <c-tab px="xl" py="md" font-weight="normal">
              {{ $t("news.blogposts.title") }}
            </c-tab>
          </c-tab-list>
        </template>
      </mobile-tab-menu>
      <c-tab-list
        mb="4xl"
        :d="{ base: 'none', lg: 'flex' }"
        v-chakra="{
          '& button[aria-selected=true], & button[data-selected]': {
            color: 'white',
            bg: 'brand.purple',
            borderColor: 'brand.purple',
          },
        }"
      >
        <c-tab px="2xl" py="sm" font-weight="normal">{{ $t("news.news.title") }}</c-tab>
        <c-tab px="2xl" py="sm" font-weight="normal">
          {{ $t("news.blogposts.title") }}
        </c-tab>
      </c-tab-list>

      <c-tab-panels>
        <!-- news -->
        <c-tab-panel>
          <c-simple-grid :columns="{ base: 1, lg: 3, xl: 4 }" :spacing="{ base: 'sm', lg: 'xl' }">
            <c-link
              v-for="newsItem in newsListing"
              :key="newsItem.link"
              :href="newsItem.link"
              target="_blank"
            >
              <c-box
                background="#4b4b4b"
                :background-image="
                  newsItem.featured_image_url && `url(${newsItem.featured_image_url})`
                "
                background-size="cover"
                background-position="center"
                background-repeat="no-repeat"
                border-radius="sharper"
                min-height="330px"
                overflow="hidden"
                position="relative"
                color="white"
                v-chakra="{
                  '&::before': {
                    content: '\'\'',
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: '100%',
                    background: 'rgba(0, 0, 0, 0.4)',
                  },
                }"
              >
                <c-box
                  v-if="newsItem.date"
                  z-index="1"
                  position="absolute"
                  top="3rem"
                  left="0"
                  px="xl"
                  py="xs"
                  border-top-right-radius="full"
                  border-bottom-right-radius="full"
                  background="brand.beige"
                  color="black"
                  font-size="xs"
                >
                  <c-text>
                    {{ newsItem.date | moment("D.M.YYYY") }}
                  </c-text>
                </c-box>
                <c-box z-index="1" position="absolute" bottom="3rem" left="xl" right="xl">
                  <c-heading as="h4" font-size="xl" font-weight="normal">
                    <span bulletin v-html="newsItem.title" />
                  </c-heading>
                </c-box>
              </c-box>
            </c-link>
          </c-simple-grid>
        </c-tab-panel>

        <!-- blogposts -->
        <c-tab-panel>
          <c-simple-grid :columns="{ base: 1, lg: 3, xl: 4 }" spacing="xl">
            <c-link
              v-for="blogpost in blogPostsListing"
              :key="blogpost.link"
              :href="blogpost.link"
              target="_blank"
            >
              <c-box
                background="#4b4b4b"
                :background-image="
                  blogpost.featured_image_url && `url(${blogpost.featured_image_url})`
                "
                background-size="cover"
                background-position="center"
                background-repeat="no-repeat"
                border-radius="sharper"
                min-height="330px"
                overflow="hidden"
                position="relative"
                color="white"
                v-chakra="{
                  '&::before': {
                    content: '\'\'',
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: '100%',
                    background: 'rgba(0, 0, 0, 0.4)',
                  },
                }"
              >
                <c-box
                  v-if="blogpost.date"
                  z-index="1"
                  position="absolute"
                  top="3rem"
                  left="0"
                  px="xl"
                  py="xs"
                  border-top-right-radius="full"
                  border-bottom-right-radius="full"
                  background="brand.beige"
                  color="black"
                  font-size="xs"
                >
                  <c-text>
                    {{ blogpost.date | moment("D.M.YYYY") }}
                  </c-text>
                </c-box>
                <c-box z-index="1" position="absolute" bottom="3rem" left="xl" right="xl">
                  <c-heading as="h4" font-size="xl" font-weight="normal">
                    <span bulletin v-html="blogpost.title" />
                  </c-heading>
                </c-box>
              </c-box>
            </c-link>
          </c-simple-grid>
        </c-tab-panel>
      </c-tab-panels>
    </c-tabs>
  </c-box>
</template>

<script lang="ts">
import MobileTabMenu from "@/components/MobileTabMenu.vue";
import {
  CBox,
  CHeading,
  CLink,
  CSimpleGrid,
  CTab,
  CTabList,
  CTabPanel,
  CTabPanels,
  CTabs,
  CText,
} from "@chakra-ui/vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "News",
  components: {
    CBox,
    CHeading,
    CTabs,
    CTabList,
    CTab,
    CTabPanels,
    CTabPanel,
    CLink,
    CSimpleGrid,
    CText,
    MobileTabMenu,
  },
  data: function () {
    return {
      activeNewsTab: 0,
      newsTabTranslationKeys: ["news.news.title", "news.blogposts.title"],
    };
  },
  computed: {
    newsListing(): any[] {
      return this.$store.state.news.news;
    },
    blogPostsListing(): any[] {
      return this.$store.state.news.blogposts;
    },
    eventsListing(): any[] {
      return this.$store.state.news.events;
    },
  },
});
</script>

<style lang="scss">
@import "../design-system/assets/tokens/tokens";

.news_section {
  margin-top: 25px;

  .row {
    padding-top: 15px;
    padding-bottom: 15px;
    font-size: 16px;
    color: #4b4b4b;
    display: flex;
    margin-right: -15px;
    margin-left: -15px;
  }

  .news-column {
    color: $color-iloq-gray-dark;
    margin-bottom: 35px;
    &:hover {
      cursor: pointer;
    }
  }

  .news-image {
    width: 100%;
    height: 260px;
    display: inline-block;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
  }

  .news-date {
    font-size: small;
    color: $color-iloq-gray-light;
  }

  .news-header {
    font-weight: bold;
  }

  .tabs-wrapper .tab-content {
    border: none;
  }

  .tabs-wrapper .tabs {
    border: none;
  }

  .tabs-wrapper .tabs li.is-active a {
    border: none;
    border-bottom: 3px solid $color-iloq-blue-light;
  }

  .tabs-wrapper .b-tabs .tabs ul li a span {
    font-size: 18px;
    font-weight: 700;
    font-family: Avenir;
    color: $color-iloq-gray-light;
  }

  .is-active a span {
    color: $color-iloq-blue-light !important;
  }
}
</style>
